<!-- <nav class="navbar topnavbar">
  <div class="w-100">
    <div class="row m-0 w-100 align-items-center">
      <div class="col-12 col-md-2 text-center text-md-start d-none">
        <a class="">
          <img src="assets/svg/credee_logo.svg" style="width: 135px" alt="">
        </a>
      </div> -->
      <div class="col-12 col-md-8 offset-md-2">
        <div class="px-2 text-center" *ngIf="planInfo && planInfo.show_denefits_logo">
          <a class="" [href]="env.server_url">
            <img src="assets/svg/credee_logo.svg" width="135px" alt="">
          </a>

        </div>
        <div class="px-2 text-center" *ngIf="planInfo && (planInfo.practice_name || planInfo.doctor_first_name) && !mainService.contractSupport && !planInfo.show_denefits_logo">
          <p class="text-light m-0 f-s-16">
            In case of any additional queries, please contact your service provider
            <b>{{planInfo && planInfo.practice_name ? planInfo.practice_name : planInfo.doctor_first_name+' '+planInfo.doctor_last_name}}</b>
            <span *ngIf="(planInfo.practice_mobile || planInfo.doctor_phone || planInfo.doctor_mobile)"> at </span>
            <a class="text-light text-bold" *ngIf="planInfo && (planInfo.practice_mobile || planInfo.doctor_phone || planInfo.doctor_mobile)"
              href="tel:{{planInfo && planInfo.practice_mobile ?planInfo.practice_mobile:planInfo.doctor_phone}}">
              {{planInfo && planInfo.practice_mobile ?(planInfo.practice_mobile | phoneNumber) : (planInfo.doctor_phone | phoneNumber) ? (planInfo.doctor_phone | phoneNumber) : (planInfo.doctor_mobile | phoneNumber)}}
            </a>
          </p>

        </div>
        <div class="px-2 text-center" *ngIf="planInfo && (planInfo.practice_name || planInfo.doctor_first_name) && mainService.contractSupport">
          <p class="text-light m-0 f-s-16">
            Need Help? <a class="text-light text-bold" href="https://www.credee.com/support" target="_blank">Click Here</a> to contact Credee Support
          </p>
        </div>
      </div>
      <!-- <div class="col-12 col-md-2">
        <div class="text-center text-sm-end">
          <button class="btn btn-outline-light btn-sm m-1" *ngIf="!hideEnv" (click)="openEnvModal(envModal)">Change
            Environment
            <small class="badge" style="background: #FFAD36;color: black;">{{environment}}</small>
          </button>
        </div>
      </div>

    </div>

  </div>
</nav> -->

<div bsModal #envModal="bs-modal" [config]="{ignoreBackdropClick:true}" class="modal fade new_modal" tabindex="-1"
  role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-md  modal-dialog-centered customModal">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title pull-left">Select Environment</h4>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col">
            <div class="checkbox c-checkbox mb-2">
              <label>
                <input type="radio" value="t1" name="env" [(ngModel)]="environment" />
                Test 1 (DEMO)</label> <span class="fa fa-check"></span>
            </div>
            <div class="checkbox c-checkbox mb-2">
              <label>
                <input type="radio" value="t2" name="env" [(ngModel)]="environment" />
                Test 2</label> <span class="fa fa-check"></span>
            </div>
            <div class="checkbox c-checkbox mb-2">
              <label>
                <input type="radio" value="t3" name="env" [(ngModel)]="environment" />
                Test 3</label> <span class="fa fa-check"></span>
            </div>
            <div class="checkbox c-checkbox mb-2">
              <label>
                <input type="radio" value="t4" name="env" [(ngModel)]="environment" />
                Test 4</label> <span class="fa fa-check"></span>
            </div>
          </div>

          <div class="col">
            <div class="checkbox c-checkbox mb-2">
              <label>
                <input type="radio" value="t5" name="env" [(ngModel)]="environment" />
                Test 5</label> <span class="fa fa-check"></span>
            </div>
            <div class="checkbox c-checkbox mb-2">
              <label>
                <input type="radio" value="t6" name="env" [(ngModel)]="environment" />
                Test 6</label> <span class="fa fa-check"></span>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" (click)="cancelChangeEnv();envModal.hide()" class="btn btn-secondary">Cancel
        </button>
        <button type="button" (click)="changeEnvironment();envModal.hide()" class="pull-right btn btn-primary">Confirm
        </button>
      </div>
    </div>
  </div>
</div>